const pad = (value: number) => String(value).padStart(2, '0')
const formatDate = (date: Date) => `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
const parseDate = (value: string) => new Date(`${value}T12:00:00`)

export function weekRange(anchor: string) {
  const value = parseDate(anchor)
  const monday = new Date(value)
  monday.setDate(value.getDate() - ((value.getDay() + 6) % 7))
  const sunday = new Date(monday)
  sunday.setDate(monday.getDate() + 6)
  return { start: formatDate(monday), end: formatDate(sunday) }
}

export function monthRange(month: string) {
  const [year, value] = month.split('-').map(Number)
  return { start: `${year}-${pad(value)}-01`, end: formatDate(new Date(year, value, 0)) }
}

export function shiftWeek(anchor: string, amount: number) {
  const value = parseDate(anchor)
  value.setDate(value.getDate() + amount * 7)
  return formatDate(value)
}

export function shiftMonth(month: string, amount: number) {
  const [year, value] = month.split('-').map(Number)
  const result = new Date(year, value - 1 + amount, 1)
  return `${result.getFullYear()}-${pad(result.getMonth() + 1)}`
}

export function recentRange(end: string, days: number) {
  const endDate = parseDate(end)
  const startDate = new Date(endDate)
  startDate.setDate(endDate.getDate() - Math.max(0, days - 1))
  return { start: formatDate(startDate), end }
}
